export function mapClickEvent(mapView, callback) {
    mapView.on('click', async (event) => {
        mapView.hitTest(event, { exclude: mapView.graphics }).then(function (response) {
            callback(response);
        });
    });
}
